
const constUserEMailKey = 'user-email';

export function getEMailFromStorage () {
  const result = window.localStorage.getItem(constUserEMailKey);
  if ((result === 'null') || ((result === null) || (typeof result === 'undefined')))
    return null;
  return result;
}

export function saveEmailToStorage (email) {
  window.localStorage.setItem(constUserEMailKey, email);
}
